import type { EventsView } from "@/lib/event-pipeline";

/** Pipeline / List switch (#1557: the page owns ?view= and the saved view). */
export function EventsViewTabs({ value, onChange }: { value: EventsView; onChange: (v: EventsView) => void }) {
  return (
    <div role="group" aria-label="View" className="inline-flex overflow-hidden rounded-lg border bg-card">
      {(["pipeline", "list"] as const).map((v) => (
        <button
          key={v}
          type="button"
          aria-pressed={value === v}
          onClick={() => onChange(v)}
          className="border-r px-4 py-[7px] text-[13.5px] font-semibold last:border-r-0 aria-pressed:bg-foreground aria-pressed:text-background"
        >
          {v === "pipeline" ? "Pipeline" : "List"}
        </button>
      ))}
    </div>
  );
}
